"use strict";export function isSharedValue(value){return!0===(null==value?void 0:value._isReanimatedSharedValue)}